export enum ProgramType {
  Choir = 1,
  Band,
  NoMTDSubscription,
  GeneralMusic,
  Orchestra,
  Mariachi,
  Other
}

export const ProgramTypeLookup: { id: ProgramType, name: string }[] = [];

ProgramTypeLookup[ProgramType.Choir] = { id: ProgramType.Choir, name: 'Choir' };
ProgramTypeLookup[ProgramType.Band] = { id: ProgramType.Band, name: 'Band' };
ProgramTypeLookup[ProgramType.NoMTDSubscription] = { id: ProgramType.NoMTDSubscription, name: 'No MTD Subscription' };
ProgramTypeLookup[ProgramType.GeneralMusic] = { id: ProgramType.GeneralMusic, name: 'General Music' };
ProgramTypeLookup[ProgramType.Orchestra] = { id: ProgramType.Orchestra, name: 'Orchestra' };
ProgramTypeLookup[ProgramType.Mariachi] = { id: ProgramType.Mariachi, name: 'Mariachi' };
ProgramTypeLookup[ProgramType.Other] = { id: ProgramType.Other, name: 'Other' };
